import React, { Component } from 'react';
import { IUpdateImageProps } from '../../models/components/profile';
import ImageCrop from './image-crop';
import { ProfileService } from '../../api/profile-service';
import {Log} from 'ng2-logger';
import Translator from '../../core/i18n';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAction, IAppState } from '../../models/action/core';
import * as Actions from '../../store/actions/profile';
import Loading from '../../components/loading/loading';

const T = Translator.create();
const _logger = Log.create('updateImageModal');
const _profileService = new ProfileService();

export class CUpdateImageModal extends Component<IUpdateImageProps, any> {

    public closeButtonRef:HTMLButtonElement|null = null;

    public state : {image: Blob | null} = {
        image: null
    };

    constructor(props: any) {
        super(props);
        this.triggerInputFile = this.triggerInputFile.bind(this);
        this.sendFile = this.sendFile.bind(this);
        this.setImage = this.setImage.bind(this);
    }

    public componentDidUpdate(prevProps: any) {
        if(this.props.isProfilePhotoUpload === true) {
            if(this.closeButtonRef) {
                this.closeButtonRef.click();
            }
        }
    }

    public triggerInputFile() {
        const input = document.getElementsByName('file-input');
        if(input) {
            input[0].click();
        }
    }

    public sendFile() {
        if(this.state.image) {
            const reader = new FileReader();
            reader.readAsDataURL(this.state.image); 
            reader.onloadend = () => {
                const base64data = reader.result;
                if(base64data !== null) {
                    const strBase64 = base64data.toString();
                    this.props.dispatch(Actions.updateProfilePhotoAction(strBase64, 'profileMainLoading', 'get'));
                }
            };
            if(this.closeButtonRef) {
                this.closeButtonRef.click();
            }
        }
    }

    public setImage(_image: Blob | null) {
        this.state.image = _image;
    }

    public render() {
        return (
            <>
            {/* <Loading top={'40%'} spinnerId={'updateImageLoading'} /> */}
            <div className="modal change-password update-image-modal" id="update-image-modal" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{T.t('r_profile_photo')}</h5>
                            <button ref={e => this.closeButtonRef=e} type="button" className="close" data-dismiss="modal" aria-label="Close" style={{marginInlineEnd: "0px"}}>
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="lead-cropper">
                            <div className="d-flex justify-content-between mini-btn">
                                <button onClick={this.triggerInputFile.bind(undefined)} type="button" className="btn btn-gray ">
                                    <i className="material-icons mr-2">
                                        cloud_download
                                    </i> {T.t('r_upload_photo')}
                                </button>
                            </div>
                        </div>
                        <ImageCrop setImage={this.setImage} />
                        <div className="modal-footer border-0 mini-btn">
                            <button data-dismiss="modal" type="button" className="btn btn-gray min-auto">{T.t('r_cancel_button')}</button>
                            <button onClick={this.sendFile} type="button" className="btn btn-green min-auto">{T.t('r_save_button')}</button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IUpdateImageProps): IUpdateImageProps => {
    if (!state) {
        return ownProps;
    }

    const newProps:IUpdateImageProps = Object.assign({}, ownProps, {
        isProfilePhotoUpload: state.profile.isProfilePhotoUpload,
        profilePhoto: state.login.identitiy.profileImagePath
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.profile.isProfilePhotoUpload === prev.profile.isProfilePhotoUpload && 
        next.login.identitiy.profileImagePath === prev.login.identitiy.profileImagePath
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const UpdateImageModal = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CUpdateImageModal);

export default UpdateImageModal;
